import { render, staticRenderFns } from "./indexColumn.vue?vue&type=template&id=61f44de7&"
import script from "./indexColumn.vue?vue&type=script&lang=ts&"
export * from "./indexColumn.vue?vue&type=script&lang=ts&"
import style0 from "./indexColumn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports